import DeleteAllCardsModal from '@components/DeleteAllCardsModal/DeleteAllCardsModal';
import DeleteCardModal from '@components/DeleteCardModal/DeleteCardModal';
import StoredCreditCards from '@components/StoredCreditCards/StoredCreditCards';
import useEmergencyState from '@hooks/useEmergencyState';
import { useTranslation } from '@hooks/useTranslations';
import CoreProviders, { CoreProvidersProps } from '@providers/CoreProviders';
import CreditCardsMutationProvider from '@providers/CreditCardsMutationProvider';
import { useErrorContext } from '@providers/ErrorContextProvider';
import { CreditCardData } from '@types-internal/index';

export interface AdyenManageCreditCardsProps extends CoreProvidersProps {
  containerType: 'myaccount' | 'default';
  isFallbackPsp: boolean;
  creditCards: CreditCardData[];
}

/*
 * On "My Account", we display the credit cards (if any, check done in StoredCreditCards).
 * And we provide ways to delete them, either individually or all at once.
 */
const AdyenManageCreditCardsSwitch: React.FC<AdyenManageCreditCardsProps> = ({
  containerType,
  isFallbackPsp,
}) => {
  const { t } = useTranslation();
  const { setError } = useErrorContext();
  const isMyAccount = containerType === 'myaccount';

  useEmergencyState(isFallbackPsp, isMyAccount, t, setError);

  if (!isMyAccount) {
    return null;
  }

  return (
    <>
      <StoredCreditCards isMyAccount={true} isFallbackPsp={isFallbackPsp} />
      <DeleteAllCardsModal />
      <DeleteCardModal />
    </>
  );
};

/**
 * Main component covering the UI on the 'editpayment' page in My Account.
 */
const AdyenManageCreditCards: React.FC<AdyenManageCreditCardsProps> = props => {
  const { env, shopBundle, locale, domain, errorContainerId, csrfToken, creditCards } = props;

  return (
    <CoreProviders
      env={env}
      shopBundle={shopBundle}
      locale={locale}
      domain={domain}
      errorContainerId={errorContainerId}
      csrfToken={csrfToken}
      featureName="adyen-credit-card">
      <CreditCardsMutationProvider
        pspToken={''}
        creditCards={creditCards}
        psp="ADYEN"
        paymentMethod="CREDIT_CARD">
        <AdyenManageCreditCardsSwitch {...props} />
      </CreditCardsMutationProvider>
    </CoreProviders>
  );
};

export default AdyenManageCreditCards;
